/**
 * Configuração do motor de recomendação por kits de uma empresa.
 *
 * Os nomes espelham o que a company-api grava e o clinical-metrics-api lê
 * (OE-1356 / OE-1567). O contrato entre as pontas é esse JSON — mudar um nome
 * aqui sem mudar nos dois backends quebra a recomendação sem erro visível.
 */
export interface IKitMatrix {
  /** Valores de rotina na ordem das colunas, do mais simples ao mais completo. */
  routines: string[];

  /** Necessidade (linha) para a lista de kits, um por coluna de `routines`. */
  matrix: Record<string, string[]>;

  kits: IKit[];

  /** Necessidades cuja linha nunca muda de coluna, em nenhuma idade. */
  fixedNeeds: string[];

  ageRule: IKitMatrixAgeRule | null;

  questions: IKitMatrixQuestions;

  /**
   * Motor por sinais (OE-1891), todos opcionais: ausentes, o kit-matrix
   * funciona como antes. A tela edita os quatro juntos como JSON; quem valida
   * o significado é o backend.
   */
  columnSignals?: string[];
  signals?: Record<string, unknown>;
  needs?: Record<string, unknown>;
  swaps?: Record<string, unknown>[];
}

export interface IKit {
  id: string;
  name: string;

  /** Opcional: ausente é ausente, nunca zero. */
  price: number | null;

  linkUrl: string | null;

  /** Produtos do kit na ORDEM DE APLICAÇÃO. */
  productIds: string[];

  /** Opcionais (OE-1891): rotina Diurna e Noturna, na ordem de aplicação. */
  morning?: string[];
  night?: string[];
}

export interface IKitMatrixAgeRule {
  triggerAgeValues: string[];
  fromColumn: number;
  toColumn: number;
}

export interface IKitMatrixQuestions {
  needByOptionId: Record<string, string>;
  routineByOptionId: Record<string, string>;
  ageByOptionId: Record<string, string>;
}

export const EMPTY_KIT_MATRIX: IKitMatrix = {
  routines: [],
  matrix: {},
  kits: [],
  fixedNeeds: [],
  ageRule: null,
  questions: {
    needByOptionId: {},
    routineByOptionId: {},
    ageByOptionId: {}
  }
};

/** Cria uma configuração vazia nova — nunca compartilhar a constante acima. */
export function createEmptyKitMatrix(): IKitMatrix {
  return {
    routines: [],
    matrix: {},
    kits: [],
    fixedNeeds: [],
    ageRule: null,
    questions: {
      needByOptionId: {},
      routineByOptionId: {},
      ageByOptionId: {}
    }
  };
}
